import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserServiceOfferReviewRepository } from './domain'

import { ReviewListQueryCriteria, UserReview } from '../../contracts/review'
import { AxiosErrorHandler, SupernovaPagedBody, SupernovaPagedResponse } from '../../foundation'

export class UserApiServiceOfferReview implements UserServiceOfferReviewRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getReviewList = async (criteria: ReviewListQueryCriteria): Promise<SupernovaPagedBody<UserReview[]>> => {
    const config: AxiosRequestConfig<ReviewListQueryCriteria> = {
      url: '/review/query/user/product-review-list/process',
      method: 'post',
      data: criteria,
    }

    try {
      const { data } = await this.axios.request<SupernovaPagedResponse<UserReview[]>>(config)
      return data.body
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
